export const globals = {}; // udrzuje globalni nastaveni
export let formData; // udrzuje puvodni json formularove data

export function setFormData(newData) {
  formData = newData; // ulozime json data jako string
}

export const setGlobals = globalsConstants => {
  Object.assign(globals, globalsConstants);
};

export const getGlobals = item => {
  if(typeof globals[item] !== 'undefined')
    return globals[item];
  return null;
};




// WEBPACK FOOTER //
// ./app/globals.js